import PostAListingSearchModule from './index';

const PostAListingSearchModuleBlock = {
  Component: PostAListingSearchModule,
  BlockRenderer: () => <PostAListingSearchModule />,
  metadata: {
    name: 'rentals/post-a-listing-search',
    title: 'Post A Listing Search',
    description: '',
    icon: 'businessperson',
    keywords: ['listing', 'search'],
    supports: {
      customClassName: false,
      html: false,
    },
    category: 'more',
    attributes: {},
  },
};

export default PostAListingSearchModuleBlock;
